import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
} from 'ramda';
import Board from './Board';
import {
  prepeareLanes,
  addTasksToStages,
  fixTasksData,
  getItemsByLaneIds,
  filterBySearchWord,
  getLaneByTicketId,
  getStageByTicketId,
} from './data';
import {
  fetchAllTasks,
  adjustTaskPositionByTaskIdAndPosition, fetchDetails,
} from '../../api/dashboard';
import CheckBox from '../../common/CheckBox';
import Input from '../../common/Input';
import styles from './styles';
import fields from './fields';
import { order } from '../../utils/order';
import Preloader from "../../common/Preloader";
import { clearLanes } from '../../actions/dashboard';

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      filters: true,
      filteredItems: [],
      useFilteredItems: false,
      fields: [],
      customStyle: {
        card: {
          width: '160px',
        },
        column: {
          width: '180px',
        },
      },
      isFullScreen: false,
      searching: false,
      loadingLines: true,
      loadingBoard: true,
    };
    this.baseState = this.state
    this.applyFilter = this.applyFilter.bind(this);
    this.disableEnableFilters = this.disableEnableFilters.bind(this);
    this.setProjectFields = this.setProjectFields.bind(this);
    this.setField = this.setField.bind(this);
    this.setNewTaskPosition = this.setNewTaskPosition.bind(this);
    this.setFullScreen = this.setFullScreen.bind(this);
    this.setNormalScreen = this.setNormalScreen.bind(this);
  }

  componentWillMount() {
    this.props.getStages();
    this.props.getTasks();
  }

  componentWillUnmount() {
    this.props.clearLanes();
    this.setState(this.baseState);
  }

  componentDidMount() {
    setTimeout(function() {
      this.setFullScreen();
    }.bind(this), 0);
  }

  componentWillReceiveProps(nextProps) {
    const lanes = path(['dashboard', 'lanes'], nextProps);

    if (this.state.fields.length === 0 && lanes) {
      this.setProjectFields(lanes);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { searching, loadingBoard, loadingLines } = this.state;
    const tasks = path(['dashboard', 'tasks'], this.props);
    const lanes = path(['dashboard', 'lanes'], this.props);
    if (searching) {
      this.applyFilter();
    }
    if (!loadingLines && tasks && loadingBoard) {
      this.setState({ loadingBoard: false });
    }
    if ( lanes && loadingLines ) {
      this.setState({ loadingLines: false });
    }
  }

  applyFilter() {
    const fields = this.state.fields;
    const lanesToShow = [];

    // Filter by lanes
    for (let i = fields.length; i--;) {
      if (fields[i].type == 'lanes' && fields[i].value === true) {
        lanesToShow.push(parseInt(fields[i].name.split('_')[1]));
      }
    }
    let extraFieldToShow = path(['dashboard', 'extra_field_to_show'], this.props) || [];

    const workOrders = filterBySearchWord(fields[0].value, path(['dashboard', 'tasks'], this.props), extraFieldToShow);
    this.setState({
      filteredItems: getItemsByLaneIds(workOrders, lanesToShow),
      useFilteredItems: true,
      searching: false,
    });
  }

  disableEnableFilters() {
    this.setState({
      filters: !this.state.filters,
    });
  }

  getFiltersIcon() {
    if (this.state.filters) {
      return (
        <i className="fa fa-eye-slash" style={{ margin: '0px', }}></i>
      );
    } else {
      return (
        <i className="fa fa-eye" style={{ margin: '0px', }}></i>
      );
    }
  }

  setField(field, newObject) {
    let stateClone = clone(this.state);
    if (field === 'search') {
      stateClone.searching = true;
    }
    else {
      stateClone.fields[field] = newObject;
    }

    this.state = mergeDeepLeft(stateClone, this.state);
    this.applyFilter();
  }

  setProjectFields(lanes) {
    const projectFields = [ fields.search, {
      label: 'Unassigned',
      placeholder: '',
      system: {
        name: '',
      },
      value: true,
      errors: [],
      type: 'lanes',
      name: 'project_' + 0,
      rules: {
        title: '',
        required: false,
      }
    }];
    for (let i = 0; i < lanes.length; i++) {
      let currentField = {
        label: lanes[i].label,
        placeholder: '',
        system: {
          name: '',
        },
        value: true,
        errors: [],
        type: 'lanes',
        name: 'project_' + lanes[i].id,
        rules: {
          title: '',
          required: false,
        }
      };
      projectFields.push(currentField);
    }
    this.setState({
      filters: true,
      fields: projectFields,
    });
  }

  getProjects() {
    const projects = [];
    for (let i = 0; i < this.state.fields.length; i++) {
      if (this.state.fields[i].type == 'lanes') {
        projects.push(
          <div style={{
            display: 'inline-block',
            border: '1px solid rgba(0, 0, 0, 0.125)',
            borderRadius: '4px',
            padding: '5px',
            marginRight: '5px',
            marginBottom: '5px',
          }}>
            <CheckBox
              customize={{
                margin: '0',
                paddingTop: '0',
                paddingBottom: '0',
              }}
              key={i}
              field={this.state.fields[i]}
              onChange={this.setField}
            />
          </div>
        );
      }
    }
    return projects;
  }

  setNewTaskPosition(data) {
    const tasks = path(['dashboard', 'tasks'], this.props) || [];
    const stages = path(['dashboard', 'stages'], this.props) || [];
    let preparedData = {
      task_id: data.id,
      position: getLaneByTicketId(tasks, data.id) + '-' + getStageByTicketId(stages, data.destination),
    };

    this.props.setNewPosition(preparedData);
  }

  setFullScreen() {
    if (!this.state.isFullScreen) {
      if (!window.mobilecheck()) {
        //document.body.style.zoom = '63.6%';
      } else {
        //document.body.style.zoom = '31%';
      }

      this.setState({
        isFullScreen: !this.state.isFullScreen,
      });
    }
  }

  setNormalScreen() {
    if (this.state.isFullScreen) {
      document.body.style.zoom = '100%';

      this.setState({
        isFullScreen: !this.state.isFullScreen,
      });
    }
  }

  renderLegendCommented() {
    return (
      <div className="col col-lg-6 col-md-12" style={{ marginTop: '5px' }}>
        <i
          className="fa fa-comment-o"
          style={{ color: 'green' }}
        />
        &nbsp;- Comment(s) Added
      </div>
    );
  }

  renderLegendAttached() {
    return (
      <div className="col col-lg-6 col-md-12" style={{ marginTop: '5px' }}>
        <i
          className="fa fa-files-o"
          style={{ color: 'green' }}
        />
        &nbsp;- Attachment(s) Uploaded
      </div>
    );
  }

  renderLegendDC(exist) {
    return (
      <div className="col col-lg-6 col-md-12" style={{ marginTop: '5px' }}>
        <span
          style={{ color: exist ? 'green' : 'red' }}
        >
          QC
        </span>
        {exist ? " - Quality Control results Uploaded" : " - Quality Control Required"}
      </div>
    );
  }

  render() {
    const { loadingBoard, loadingLines } = this.state;
    const lanes = path(['dashboard', 'lanes'], this.props) || [];
    let stages = path(['dashboard', 'stages'], this.props) || [];
    stages = stages.filter(stage => stage.show_on_dashboard === 1);

    let extraFieldToShow = path(['dashboard', 'extra_field_to_show'], this.props) || [];
    if (stages && stages.length > 0) {
      stages = order(stages, 'order');
    }
    let filterBlock = 'block';
    let tasks = path(['dashboard', 'tasks'], this.props);
    if (this.state.useFilteredItems === true) {
      tasks = this.state.filteredItems;
    }
    let boardLanes = prepeareLanes(lanes, stages);

    if (tasks) {
      tasks = fixTasksData(tasks);
      boardLanes = addTasksToStages(tasks, stages);
    }
    if (!this.state.filters) {
      filterBlock = 'none';
    }
    let linesPart;
    if(loadingLines){
      linesPart = <Preloader show={true} type='circle' />;
    } else {
      linesPart = this.getProjects();
    }
    let boardPart;
    if(loadingBoard){
      boardPart = <Preloader show={true} type='circle' />;
    } else {
        boardPart = <Board
          extraFieldToShow={extraFieldToShow}
          initial={boardLanes}
          lanesList={lanes}
          handler={this.setNewTaskPosition}
          handlerOpenTask={this.props.openTask}
          handlerOpenPreView={this.props.openPreView}
          isFullScreen={this.state.isFullScreen}
        />;
    }
    return (
      <div
        style={{
          position: 'relative'
        }}
      >
        <div className="card" style={styles.rounded}>
          <div className="card-header">
            <div className="row">
              <div className="col">
                <h4 style={{ paddingTop: '7px' }}>Filters</h4>
              </div>
              <div className="col">
                <button
                  className="btn btn-rounded btn-icon ui-btn pull-right"
                  onClick={this.disableEnableFilters}
                  style={{ borderRadius: '4px', padding: '10px', }}
                >
                  {this.getFiltersIcon()}
                </button>
                {false && this.screenSwitcher()}
                {/*<button*/}
                {/*className="btn btn-rounded btn-icon ui-btn pull-right"*/}
                {/*onClick={this.applyFilter}*/}
                {/*style={{ borderRadius: '4px' }}*/}
                {/*>*/}
                {/*<i className="fa fa-filter"></i>*/}
                {/*Apply*/}
                {/*</button>*/}
              </div>
            </div>
          </div>
          <div className="card-block" style={{ display: filterBlock }}>
            <div className="row">
              <div className="col">
                <div className="row">
                  <div className="col col-md-12" style={{ paddingBottom: '10px' }}>
                    <b>Projects:</b>
                  </div>
                  <div className="col col-md-12">
                    {linesPart}
                  </div>
                </div>
              </div>
              <div className="col">
                <Input
                  field={this.state.fields[0]}
                  onChange={this.setField}
                />
                <div className="row">
                  {this.renderLegendDC()}
                  {this.renderLegendDC(true)}
                  {this.renderLegendAttached()}
                  {this.renderLegendCommented()}
                </div>
              </div>
            </div>
          </div>
        </div>
        {boardPart}
      </div>
    );
  }

  changeScreenHandler = () => {
    if (this.state.isFullScreen) {
      this.setNormalScreen();
    }
    else {
      this.setFullScreen();
    }
  };

  screenSwitcher() {
    return (<button
      className="btn btn-rounded btn-icon ui-btn pull-right"
      onClick={this.changeScreenHandler}
      style={{ marginRight: '10px', borderRadius: '4px' }}
    >
      {!this.state.isFullScreen && <span><i className="fa fa-expand"></i> Full Screen</span>}
      {this.state.isFullScreen && <span>Normal Screen</span>}
    </button>);
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearLanes: () => {
      dispatch(clearLanes());
    },
    getStages: () => {
      fetchDetails()(dispatch);
    },
    getTasks: () => {
      fetchAllTasks()(dispatch);
    },
    setNewPosition: (data) => {
      adjustTaskPositionByTaskIdAndPosition(data)(dispatch);
    },
    openTask: (id) => {
      dispatch(push('/pages/task/' + id));
    },
    openPreView: (id) => {
      dispatch(push('/pages/dashboard-pre-view/' + id));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js